/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { StirringMethodBase } from "../../../../schema/generated/StirringMethod";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class StirringMethodDataApi extends EntityDataApi<StirringMethodBase> {
  public readonly def = idbEntityDefs.StirringMethod;
}